<template>
  <div class="survey-main">
    <div id="feedback-form">
      <h1 class="center-it bold">{{ property.name }}</h1>
      <h2>Give Us Feedback</h2>
      <form>
        <div v-if="isError" class="error">Error with form<br /></div>
        <p>How was your experience?</p>
        <textarea v-model="payload.feedback_text" required /><br />
        <div v-if="isFeedbackTextError" class="error">No Feedback</div>
        <br />
        <p>How does your experience make you feel?</p>
        <div id="emotion" class="emoji">
          <input
            id="happy"
            v-model="payload.feedback_rating"
            class="input_hidden"
            type="radio"
            name="emotion"
            value="10"
          />
          <label
            :class="{ selected: 10 == selected }"
            for="happy"
            @click="setFeedbackRating(10)"
            ><img src="../assets/happy.png"
          /></label>
          <input
            id="neutral"
            v-model="payload.feedback_rating"
            class="input_hidden"
            type="radio"
            name="emotion"
            value="5"
          />
          <label
            :class="{ selected: 5 == selected }"
            for="neutral"
            @click="setFeedbackRating(5)"
            ><img src="../assets/neutral.png"
          /></label>
          <input
            id="sad"
            v-model="payload.feedback_rating"
            class="input_hidden"
            type="radio"
            name="emotion"
            value="1"
          />
          <label
            :class="{ selected: 1 == selected }"
            for="mad"
            @click="setFeedbackRating(1)"
            ><img src="../assets/mad.png"
          /></label>
        </div>
        <div v-if="isFeedbackRatingError" class="error">Not Selected</div>
        <br />
        <p>Would you recommend us to a friend?</p>
        <input
          v-model="payload.referral_rating"
          type="radio"
          name="refer"
          value="10"
        />
        <label class="refer" for="referChoiceYes">Yes</label>&nbsp;&nbsp;
        <input
          v-model="payload.referral_rating"
          type="radio"
          name="refer"
          value="1"
        />
        <label class="refer" for="referChoiceNo">No</label><br />
        <div v-if="isFeedbackReferralError" class="error">Not Selected</div>
        <br /><br />
        <div v-if="isTokenError" class="error">No Token</div>
        <button
          type="button"
          class="button button-300 button-form"
          @click="createFeedback"
        >
          Send Feedback</button
        ><br />
        <div v-if="feedbackReceivedMessage" class="error form-300">
          Feedback Received
        </div>
        <br />
      </form>
      <span class="center-it">Powered By</span>
      <a href="https://www.machinecore.com/" target="_new">
        <img
          class="powered-logo"
          src="../assets/machinecore_logo_small_final@2x.png"
          srcset="
            ../assets/machinecore_logo_small_final@1x.png 1x,
            ../assets/machinecore_logo_small_final@2x.png 2x
          "
        />
      </a>
      <br />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import api from "@/api/index";
const apiService = new api.APIServiceFeedbackDashboard();
const apiServiceFeedback = new api.APIServiceFeedback();

export default {
  data() {
    return {
      payload: {
        feedback_rating: "",
        referral_rating: "",
        feedback_text: "",
        token: this.$route.params.token
      },
      property: "",
      isError: false,
      isFeedbackTextError: false,
      isFeedbackRatingError: false,
      isFeedbackReferralError: false,
      isTokenError: false,
      selected: undefined,
      feedbackReceivedMessage: false
    };
  },
  created() {
    this.clearForm();
    this.getSurveyProperty(this.$route.params.token);
  },
  methods: {
    getSurveyProperty: function(token) {
      apiService.getSurveyProperty(token).then(data => {
        this.property = data.data;
      });
    },
    createFeedback: function(e) {
      this.isError = false;
      this.isFeedbackTextError = false;
      this.isFeedbackRatingError = false;
      this.isFeedbackReferralError = false;
      this.feedbackReceivedMessage = false;
      if (!this.payload.feedback_text) {
        this.isError = true;
        this.isFeedbackTextError = true;
      }
      if (!this.payload.token) {
        this.isError = true;
        this.isTokenError = true;
      }
      if (!this.payload.feedback_rating) {
        this.isError = true;
        this.isFeedbackRatingError = true;
      }
      if (!this.payload.referral_rating) {
        this.isError = true;
        this.isFeedbackReferralError = true;
      }
      if (!this.isError) {
        this.feedbackReceivedMessage = false;
        // this.$store.dispatch('createFeedback', this.payload);
        apiServiceFeedback
          .createFeedback(this.payload)
          .then(data => {})
          .catch(e => {
            this.isError = true;
          });
        this.clearForm();
        this.feedbackReceivedMessage = true;
        this.payload.feedback_text = "";
        this.payload.feedback_rating = "";
        this.payload.referral_rating = "";
      }
    },
    setFeedbackRating: function(rating) {
      this.selected = rating;
      this.payload.feedback_rating = rating;
    },
    clearForm: function() {
      this.feedbackReceivedMessage = false;
      this.payload.feedback_text = "";
      this.payload.feedback_rating = "";
      this.payload.referral_rating = "";
      this.isError = false;
      this.isFeedbackTextError = false;
      this.isFeedbackRatingError = false;
      this.isFeedbackReferralError = false;
      this.isTokenError = false;
      this.selected = undefined;
    }
  }
};
</script>
<style>
html {
  background: #fafafa;
}
#feedback-form {
  margin: 60px auto 0 auto;
  padding: 20px;
  width: 442px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 5px 15px 0 rgba(0, 0, 0, 0.05);
  background-color: #ffffff;
  border-radius: 4px;
  border: 1px solid #cfe1f6;
}
#feedback-form h1 {
  font-size: 30px;
}
#feedback-form p {
  font-size: 16px;
  margin-bottom: 5px;
}
.button-form {
  margin: 0 auto;
  display: block;
}
.emoji img {
  width: 35px;
}
.input_hidden {
  position: absolute;
  left: -9999px;
}
.selected {
  background-color: #90c64d;
  border-radius: 4px;
}
#emotion label {
  display: inline-block;
  cursor: pointer;
  margin-right: 20px;
  width: 35px;
  height: 35px;
}
#feedback-form label.refer {
  font-size: 18px;
  padding-left: 4px;
}
#feedback-form textarea {
  font-size: 1.2em;
  padding: 6px;
  width: 400px;
  height: 200px;
  border-radius: 6px;
  color: #b8b8b8;
}
#feedback-form input[type="radio"]:after {
  width: 15px;
  height: 15px;
  border-radius: 15px;
  top: -1px;
  left: -1px;
  position: relative;
  background-color: #d1d3d1;
  content: "";
  display: inline-block;
  visibility: visible;
  border: 2px solid white;
}
#feedback-form input[type="radio"]:checked:after {
  width: 15px;
  height: 15px;
  border-radius: 15px;
  top: -1px;
  left: -1px;
  position: relative;
  background-color: #90c64d;
  content: "";
  display: inline-block;
  visibility: visible;
  border: 2px solid white;
}
#feedback-form img.powered-logo {
  margin: 0 auto;
  display: block;
  width: 50%;
}
#feedback-form .center-it {
  display: block;
  text-align: center;
}
input[type="text"].token {
  font-size: 12px;
  width: 300px;
}
@media (max-width: 441px) {
  #feedback-form {
    margin: 20px auto 0 auto;
    padding: 20px 10px;
    width: 100%;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05),
      0 5px 15px 0 rgba(0, 0, 0, 0.05);
    background-color: #ffffff;
    border-radius: 0px;
    border: 1px solid #cfe1f6;
  }
  #feedback-form textarea {
    width: 100%;
    height: 200px;
    border-radius: 6px;
    color: #b8b8b8;
  }
  #feedback-form button {
    width: 100%;
  }
}
</style>
